import React from 'react';
import { writeErr } from '../../common/logger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RelationsSearchRow from "./relationsSearchRow";
import { withLocalize, Translate } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { relationsSearchActions, searchType, defaultPaging, searchInstances } from '../../../store/relationsSearchStore';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { registerHook, unregisterHook, isClickTo } from "../../../store/clickWrapper";
import { isOnPath } from '../../../store/apiWrapper';
import classnames from 'classnames';
import ReactResizeDetector from 'react-resize-detector';
import PerfectScrollbar from 'react-perfect-scrollbar';

import '../quickSearchResults.scss';
import { getClientWindowHeight, getElementBoundingRect, getScrollY, getElementHeight } from '../../../store/almightyElementWrapper';

class RelationsSearchQuickSearchResults extends React.Component {
    state = {
        maxInnerWidth: 0
    };

    searchResultsRef = undefined;

    updateScrollbar = () => {
        if (this._scrollRef !== null && this._scrollRef !== undefined) {
            this._scrollRef._ps.update(); // also needs to be called to update scrollbar after path change
            this._scrollRef.updateScroll();
        }
    }

    componentDidUpdate(prevProps) {
        if (!isNullOrUndefined(this.props.sr) && !isNullOrUndefined(this.props.sr.subjects)
            && !isNullOrUndefined(prevProps.sr) && !isNullOrUndefined(prevProps.sr.subjects)
            && this.props.sr.subjects != prevProps.sr.subjects && this._scrollRef !== null && this._scrollRef !== undefined) {
            this.updateScrollbar(this._scrollRef);
        }
    }

    componentDidMount() {
        this.hookId = registerHook(this, (click) => {
            if (this.props[this.props.searchInstance.key].quickSearchResults[this.props.subId] && !isClickTo(click, [...this.props.searchInputRef, this.searchResultsRef])) {
                this.props.hideQuickSearchResults(this.props.searchInstance.key, this.props.subId);
            }
        });

        this.updateScrollbar();
    }

    componentWillUnmount() {
        unregisterHook(this.hookId);
    }

    render() {
        if (isNullOrUndefined(this.props.sr)) {
            if (this.props.ls.length > 0 && (this.props.query === null || this.props.query === undefined || this.props.query === '')) {
                return this.renderLastSubjectsWidget();
            }
            return null;
        }

        if (!isNullOrUndefined(this.props.sr.error)) {
            writeErr(this.props.sr.error.reason);
            return this.renderError("Search.Error");
        }

        if (isNullOrUndefined(this.props.sr.subjects) || this.props.sr.subjects.length === 0)
            return this.renderError("Search.NoData", null, "#444749");

        const mode = this.props.mode || { extraData: 'desktop', basicLink: 'desktop', buttons: 'desktop' };


        return (
            <div className={classnames('qs-results', { 'qs-condensed': this.props.condensed })} style={{ maxHeight: this.getMaxHeight(), width: this.getInputWidth() }}
                ref={(el) => this.searchResultsRef = el}>
                <ReactResizeDetector handleWidth refreshMode='debounce' refreshRate={500} onResize={this.onResize} />
                <PerfectScrollbar ref={el => this._scrollRef = el}>
                    <div className='qs-results-scrolled-content'>
                        {this.props.sr.subjects.map(s =>
                            <RelationsSearchRow condensed={this.props.condensed}
                                key={s.entityId} s={s} mode={mode} maxTableWidth={this.state.maxInnerWidth - 70}
                                onResultMouseClicked={(e) => this.entityLinkClick(e, s.entityId, s.queryName, s.ico, s.dateOfBirth)} quickReportLink={false} />
                        )}
                    </div>
                </PerfectScrollbar>
            </div>
        )
    }

    getInputWidth = () => {
        return (this.props.searchInstance.key === searchInstances.cre || this.props.searchInstance.key === searchInstances.cee || this.props.searchInstance.key === searchInstances.aml)? document.getElementById('quickSearchInput').clientWidth + 'px' : null;
    }

    getMaxHeight = () => {
        //min footer is 3.5rem
        const fallback = getClientWindowHeight() * 0.6 - this.convertRemToPixels(3.5);
        const expected = (window.innerHeight - getElementBoundingRect('search-box', _ => _.bottom) + getScrollY()) - 8 - getElementHeight({ className: 'footer' });
        return Math.min(fallback, expected);
    }
    convertRemToPixels(rem) {
        return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
    }

    renderLastSubjectsWidget = () => {
        return (
            <div
                className={classnames("qs-results", { 'hide-on-mobile': this.props.hideLastSubjectsOnMobile })}
                style={{ maxHeight: this.getMaxHeight(), width: this.getInputWidth() }}
                ref={(el) => this.searchResultsRef = el}
            >
                <ReactResizeDetector handleWidth refreshMode='debounce' refreshRate={500} onResize={this.onResize} />
                <PerfectScrollbar>
                    <div className='qs-results-scrolled-content'>
                        {!this.props.subjectsLoading && isNullOrUndefined(this.props.subjectsError) && this.props.ls
                            .filter((f) => { return isNullOrUndefined(this.props.lsFilterType) || this.props.lsFilterType === f.type })
                            .map(s => <RelationsSearchRow maxTableWidth={this.state.maxInnerWidth - 70} condensed={this.props.condensed}
                                key={s.entityId} s={s} mode={this.props.mode}
                                onResultMouseClicked={(e) => this.entityLinkClick(e, s.entityId, s.queryName, s.ico, s.dateOfBirth)} quickReportLink={false} />
                            )}
                    </div>
                </PerfectScrollbar>
                {!this.props.subjectsLoading && !isNullOrUndefined(this.props.subjectsError) && this.renderApiError(this.props.subjectsError, "sad-cry")}
            </div>
        );
    }

    onResize = (width, height) => {
        this.setState({ maxInnerWidth: width });
    }

    renderError = (translationKey, icon = null, color = "Red") => {
        return (
            <div className="qs-results" ref={(el) => this.searchResultsRef = el}>
                {icon && <div className="qs-glyph"><FontAwesomeIcon icon={icon} size="6x" /></div>}
                <div className="qs-error" style={{ color: color }}><Translate id={translationKey} /></div>
            </div>
        )
    }

    renderApiError = (error, icon = null) => {
        return (
            <div>
                {icon && <div className="qs-glyph"><FontAwesomeIcon icon={icon} size="6x" /></div>}
                <div className="qs-error"><Translate id="Common.ApiError" /></div>
                <div className="qs-error">{error.code} - {error.message}</div>
            </div>
        )
    }

    entityLinkClick = (e, entityId, query, ico, dob) => {
        if (e.button !== 0) {
            return;
        }
        if (isOnPath({ prefix: "/search/results" })) {
            let params = { country: 3, actualOnly: true };
            params.name = query;
            //makes the query
            this.props.getRelationsSubjects(this.props.searchInstance.Key, searchType.QS, params, { ...defaultPaging });
        }

        //insert into history so there is track of what has been searched              
        this.props.hideQuickSearchResults(this.props.searchInstance.key, 'mainSearch');
        this.props.toggleForm(this.props.searchInstance.key, false);
        if (this.props.isPo === true && !isNullOrUndefined(ico) && ico !== '')
            query = ico.replace('<em>', '').replace('</em>', '');
        var submitParams = { entityId: entityId, query: `type=${encodeURIComponent(searchType.QS)}&q=${encodeURIComponent(query)}&isPo=${encodeURIComponent(this.props.isPo)}` };
        if (this.props.isPo === false && !isNullOrUndefined(dob) && dob !== '')
            submitParams.query += `&dob=${encodeURIComponent(dob)}`;
        this.props.onAction("submit", submitParams);
    }
}

export default withRouter(withLocalize(connect(
    state => ({ ...state.relationsSearch, ...state.layout }),
    dispatch => bindActionCreators(relationsSearchActions, dispatch),
)(RelationsSearchQuickSearchResults)));